export default {
  SUBAMIN_LIST_REQUEST: 'APP/SUBAMIN_LIST/SUBAMIN_LIST_LIST_REQUEST',
  SUBAMIN_MGMT_LIST_SUCCESS: 'APP/SUBAMIN_LIST/SUBAMIN_LIST_LIST_SUCCESS',
  SUBAMIN_MGMT_LIST_ERROR: 'APP/SUBAMIN_LIST/SUBAMIN_LIST_LIST_ERROR',
};
